/* tslint:disable */
/* eslint-disable */
/**
 * cro-fiona-conversions
 * funnel metrics / conversions callbacks
 *
 * The version of the OpenAPI document: 0.1.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Conversion,
    ImpressionFilter,
    ImpressionFilter1,
    ImpressionRequest,
    ImpressionWithId,
    ImpressionWithRelations,
} from '../models';

export interface ImpressionControllerConvertImpressionRequest {
    id: string;
    price?: string;
    metadata?: string;
    status?: string;
}

export interface ImpressionControllerCreateRequest {
    impressionRequest?: ImpressionRequest;
}

export interface ImpressionControllerFindRequest {
    filter?: ImpressionFilter1;
}

export interface ImpressionControllerFindByIdRequest {
    id: string;
    filter?: ImpressionFilter;
}

/**
 * ImpressionControllerApi - interface
 * 
 * @export
 * @interface ImpressionControllerApiInterface
 */
export interface ImpressionControllerApiInterface {
    /**
     * 
     * @param {string} id 
     * @param {string} [price] 
     * @param {string} [metadata] 
     * @param {string} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpressionControllerApiInterface
     */
    impressionControllerConvertImpressionRaw(requestParameters: ImpressionControllerConvertImpressionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Conversion>>;

    /**
     */
    impressionControllerConvertImpression(requestParameters: ImpressionControllerConvertImpressionRequest, initOverrides?: RequestInit): Promise<Conversion>;

    /**
     * 
     * @param {ImpressionRequest} [impressionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpressionControllerApiInterface
     */
    impressionControllerCreateRaw(requestParameters: ImpressionControllerCreateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ImpressionWithId>>;

    /**
     */
    impressionControllerCreate(requestParameters: ImpressionControllerCreateRequest, initOverrides?: RequestInit): Promise<ImpressionWithId>;

    /**
     * 
     * @param {ImpressionFilter1} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpressionControllerApiInterface
     */
    impressionControllerFindRaw(requestParameters: ImpressionControllerFindRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ImpressionWithRelations>>>;

    /**
     */
    impressionControllerFind(requestParameters: ImpressionControllerFindRequest, initOverrides?: RequestInit): Promise<Array<ImpressionWithRelations>>;

    /**
     * 
     * @param {string} id 
     * @param {ImpressionFilter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpressionControllerApiInterface
     */
    impressionControllerFindByIdRaw(requestParameters: ImpressionControllerFindByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ImpressionWithRelations>>;

    /**
     */
    impressionControllerFindById(requestParameters: ImpressionControllerFindByIdRequest, initOverrides?: RequestInit): Promise<ImpressionWithRelations>;

}

/**
 * 
 */
export class ImpressionControllerApi extends runtime.BaseAPI implements ImpressionControllerApiInterface {

    /**
     */
    async impressionControllerConvertImpressionRaw(requestParameters: ImpressionControllerConvertImpressionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Conversion>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling impressionControllerConvertImpression.');
        }

        const queryParameters: any = {};

        if (requestParameters.price !== undefined) {
            queryParameters['price'] = requestParameters.price;
        }

        if (requestParameters.metadata !== undefined) {
            queryParameters['metadata'] = requestParameters.metadata;
        }

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/impressions/{id}/convert`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async impressionControllerConvertImpression(requestParameters: ImpressionControllerConvertImpressionRequest, initOverrides?: RequestInit): Promise<Conversion> {
        const response = await this.impressionControllerConvertImpressionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async impressionControllerCreateRaw(requestParameters: ImpressionControllerCreateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ImpressionWithId>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/impressions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.impressionRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async impressionControllerCreate(requestParameters: ImpressionControllerCreateRequest = {}, initOverrides?: RequestInit): Promise<ImpressionWithId> {
        const response = await this.impressionControllerCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async impressionControllerFindRaw(requestParameters: ImpressionControllerFindRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ImpressionWithRelations>>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/impressions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async impressionControllerFind(requestParameters: ImpressionControllerFindRequest = {}, initOverrides?: RequestInit): Promise<Array<ImpressionWithRelations>> {
        const response = await this.impressionControllerFindRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async impressionControllerFindByIdRaw(requestParameters: ImpressionControllerFindByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<ImpressionWithRelations>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling impressionControllerFindById.');
        }

        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/impressions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async impressionControllerFindById(requestParameters: ImpressionControllerFindByIdRequest, initOverrides?: RequestInit): Promise<ImpressionWithRelations> {
        const response = await this.impressionControllerFindByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
